import { useMemo } from "react";
import { Product } from "@/services/productService";

const useIsProductSingleSize = (product: Product) => {
  return useMemo(() => {
    const productSizes = product?.sizes || [];
    const productFirstSize = productSizes?.[0]?.variants[0];
    return productFirstSize?.sizeId === 0;
  }, [product]);
};

export default useIsProductSingleSize;
